// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__WW-nR","row":"styles_row__3O113"};